import React from 'react';
import { Star } from 'lucide-react';

const RatingsOverview = ({ ratings }) => {
  const { averageRating, totalRatings, ratingCounts, reviewsCount } = ratings;

  // Calculate the width of each bar based on actual count instead of percentage
  const maxCount = Math.max(...Object.values(ratingCounts), 1); // Avoid division by zero

  return (
    <div className="bg-green-50 rounded-lg p-6">
      <div className="flex flex-col">
        {/* Top - Big rating number */}
        <div className="mb-4">
          <div className="text-6xl font-bold text-gray-800">
            {averageRating}
          </div>
          <div className="flex mt-1">
            {[1, 2, 3, 4, 5].map((star) => (
              <Star
                key={star}
                className={`w-6 h-6 ${
                  star <= Math.round(averageRating)
                    ? "fill-yellow-400 text-yellow-400"
                    : "fill-gray-200 text-gray-200"
                }`}
              />
            ))}
          </div>
          <div className="text-sm mt-1 font-bold">
            <span className="font-black text-lg">{totalRatings} total ratings</span>
            {reviewsCount > 0 && totalRatings !== reviewsCount && (
              <span>, {reviewsCount} with reviews</span>
            )}
          </div>
        </div>

        {/* Bottom - Rating bars */}
        <div className="w-full">
          {[5, 4, 3, 2, 1].map((rating) => {
            const count = ratingCounts[rating] || 0;

            // Calculate width as a percentage of the max count to ensure bars are visible
            const barWidth = maxCount > 0 ? (count / maxCount) * 100 : 0;

            return (
              <div key={rating} className="flex items-center mb-2">
                <div className="w-12 text-md mr-2" style={{fontWeight:700}}>{rating} star</div>
                <div className="flex-1 bg-gray-200 h-2 rounded-full overflow-hidden">
                  <div
                    className="bg-yellow-400 h-full rounded-full"
                    style={{ width: `${barWidth}%` }}
                  ></div>
                </div>
                <div className="text-xs text-gray-600 ml-2 w-10" style={{fontWeight:700}}>
                  ({count})
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RatingsOverview;